// Fatia `planos + assinatura` do slice `aiFramework/creditos` (spec-005, [T026]).
//
// ★ POR QUE ARQUIVO PRÓPRIO, E NÃO OUTRO MÓDULO VUEX. O plano recorrente compartilha
// state com o resto da carteira — cancelar relê o SALDO, e o saldo utilizável só existe
// por causa do ciclo do plano. Um módulo namespaced separado obrigaria cada ação a
// despachar com `{ root: true }` para o irmão, e a tela leria dois saldos de dois lugares.
// O que se separa aqui é o ARQUIVO: `creditos.js` já passava de 550 linhas antes desta
// spec, e o assunto "plano" é fechado o bastante para ser lido de uma vez.
//
// ★ QUEM BUSCA É A API (review #2211, M5). O catálogo, a leitura da assinatura e as três
// escritas (assinar, cancelar, reativar) moram em `apiAiFrameworkAssinatura`, que faz o
// request e persiste o desfecho aqui pelos setters abaixo — molde de
// `_templates/new/api/api.ejs.t`. As duas disciplinas opostas (leitura VERSIONADA ×
// escrita com guard BLOQUEANTE) estão descritas lá, junto do código que as aplica.
// ── State ─────────────────────────────────────────────────────────────────────────────
function stateAssinatura() {
  return {
    // ── spec-005 ([T026]): o plano recorrente ──
    // Catálogo de planos: envelope { planos: [...] } ou null. `planos: []` é catálogo
    // VAZIO (estado de tela) e é diferente de `null` (não carregado) — a mesma
    // distinção dos pacotes avulsos.
    planos: null,
    planosLoading: false,
    planosErro: null,

    // ★ `assinatura: null` é ESTADO VÁLIDO — "este profissional não assina" — e não
    // ausência de dado: é o estado da maioria da base, e a tela responde a ele
    // mostrando os planos. Quem distingue "não assina" de "não consegui ler" é o
    // `assinaturaErro`: null nos dois casos faria a tela oferecer planos a quem já
    // tem um, sempre que a leitura falhasse.
    assinatura: null,
    assinaturaLoading: false,
    assinaturaErro: null,
    // ★ Erro de ESCRITA, separado do de leitura de propósito. Um 409 de "você já tem um
    // plano" não pode apagar da tela o cartão do plano que o consultor TEM — que é o que
    // aconteceria se as duas falhas dividissem o mesmo campo, porque o cartão troca o
    // conteúdo por um bloco de erro quando a leitura falha.
    // `{ message, idAssinatura }` ou null, a forma do `checkoutErro`: o `idAssinatura` só
    // existe no 502 e é o protocolo do suporte (review #2211, S20).
    assinaturaAcaoErro: null,
    // Guard das TRÊS escritas (assinar, cancelar, reativar). Uma flag só, e não três:
    // as ações são mutuamente exclusivas na tela, e o botão de cada uma some enquanto
    // a outra roda.
    assinaturaAcaoLoading: false,
  }
}

// ── Getters ───────────────────────────────────────────────────────────────────────────
const gettersAssinatura = {
  planos: (s) => s.planos,
  planosLoading: (s) => s.planosLoading,
  planosErro: (s) => s.planosErro,

  assinatura: (s) => s.assinatura,
  assinaturaLoading: (s) => s.assinaturaLoading,
  assinaturaErro: (s) => s.assinaturaErro,
  assinaturaAcaoErro: (s) => s.assinaturaAcaoErro,
  assinaturaAcaoLoading: (s) => s.assinaturaAcaoLoading,
}

// ── Mutations ─────────────────────────────────────────────────────────────────────────
const mutationsAssinatura = {
  SET_PLANOS(s, payload) {
    s.planos = payload || null
  },
  SET_PLANOS_LOADING(s, payload) {
    s.planosLoading = payload
  },
  SET_PLANOS_ERRO(s, payload) {
    s.planosErro = payload || null
  },

  SET_ASSINATURA(s, payload) {
    s.assinatura = payload || null
  },
  SET_ASSINATURA_LOADING(s, payload) {
    s.assinaturaLoading = payload
  },
  SET_ASSINATURA_ERRO(s, payload) {
    s.assinaturaErro = payload || null
  },
  SET_ASSINATURA_ACAO_ERRO(s, payload) {
    s.assinaturaAcaoErro = payload || null
  },
  SET_ASSINATURA_ACAO_LOADING(s, payload) {
    s.assinaturaAcaoLoading = payload
  },
}

// ── Actions ───────────────────────────────────────────────────────────────────────────
// Setters (review #2211, M5): só commitam. Quem os chama é a `apiAiFrameworkAssinatura`,
// depois de ler ou escrever no servidor.
const actionsAssinatura = {
  setPlanos({ commit }, payload) {
    commit('SET_PLANOS', payload)
  },
  setPlanosLoading({ commit }, payload) {
    commit('SET_PLANOS_LOADING', payload)
  },
  setPlanosErro({ commit }, payload) {
    commit('SET_PLANOS_ERRO', payload)
  },
  setAssinatura({ commit }, payload) {
    commit('SET_ASSINATURA', payload)
  },
  setAssinaturaLoading({ commit }, payload) {
    commit('SET_ASSINATURA_LOADING', payload)
  },
  setAssinaturaErro({ commit }, payload) {
    commit('SET_ASSINATURA_ERRO', payload)
  },
  setAssinaturaAcaoErro({ commit }, payload) {
    commit('SET_ASSINATURA_ACAO_ERRO', payload)
  },
  setAssinaturaAcaoLoading({ commit }, payload) {
    commit('SET_ASSINATURA_ACAO_LOADING', payload)
  },
}

export { stateAssinatura, gettersAssinatura, mutationsAssinatura, actionsAssinatura }
